module.exports = __webpack_public_path__ + "static/media/amusement(20).9798a72b.PNG";